export const CLOSE_FROM_MODAL = 'close_from_modal';
export const OPEN_CREATE_FOLDER_MODAL = 'open_create_folder_modal';
export const CREATE_FOLDER = 'create_folder';
export const CREATE_FOLDER_FAILED = 'create_folder_failed';